module.exports = __webpack_public_path__ + "static/media/save-btn.831cc8cf.png";